/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sms_Status_ErrorInputs */

const cs_sms_status_error = /** @type {(inputs: Sms_Status_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stav SMS se nepodařilo načíst.`)
};

const en_sms_status_error = /** @type {(inputs: Sms_Status_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load SMS status.`)
};

/**
* | output |
* | --- |
* | "Could not load SMS status." |
*
* @param {Sms_Status_ErrorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sms_status_error = /** @type {((inputs?: Sms_Status_ErrorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sms_Status_ErrorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sms_status_error(inputs)
	return cs_sms_status_error(inputs)
});